import React from "react";
import {Route, Redirect} from "react-router-dom";
import {isExistToken} from '../../utils/common';
import { ROUTES } from "../../utils/constants";

interface Props {
    children: React.ReactNode;
    path: string;
}

const LobbyRoute = ({ children, path, ...rest }: Props) => {
    return (
        <Route
            {...rest}
            path={path}
            render={({ location }) =>
                isExistToken() ? (<Redirect to={{pathname: ROUTES.ROOT, state: { from: location }}}/>) : (children)
            }
        />
    );
}

export default React.memo(LobbyRoute);